exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-reset[data-v-539b88a3]:disabled{background-image:none;cursor:not-allowed}.disable-reset[data-v-539b88a3]:disabled:hover{background-image:none}", ""]);

// exports
